module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.deno/core-js@2.6.12/~/core-js/library/modules/_library.js
// module id = 44
// module chunks = 0